"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.otherAdjustmentExtendedSchema = void 0;
var constants_1 = require("@hobt/constants");
var other_adjustment_schema_1 = require("./other-adjustment-schema");
exports.otherAdjustmentExtendedSchema = __assign(__assign({}, other_adjustment_schema_1.otherAdjustmentSchema), { allOf: [
        // If code = 500 then numberOfDaysOverrideFlag is required
        {
            if: {
                required: ['code', 'numberOfDaysCount'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.ProcessTime,
                    },
                },
            },
            then: {
                required: ['numberOfDaysOverrideFlag'],
            },
        },
        // If code = 501 or 503 then amountOverrideFlag and numberOfDaysOverrideFlag are required
        {
            if: {
                required: ['code', 'amount', 'numberOfDaysCount'],
                properties: {
                    code: {
                        enum: [constants_1.OtherAdjustmentCode.LateFiling, constants_1.OtherAdjustmentCode.LegalActionDelayFee],
                    },
                },
            },
            then: {
                required: ['amountOverrideFlag', 'numberOfDaysOverrideFlag'],
            },
        },
        // If code != 500, 501 or 503 then amountOverrideFlag and numberOfDaysOverrideFlag are forbidden
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        enum: [
                            constants_1.OtherAdjustmentCode.ProcessTime,
                            constants_1.OtherAdjustmentCode.LateFiling,
                            constants_1.OtherAdjustmentCode.LegalActionDelayFee,
                        ],
                    },
                },
            },
            else: {
                properties: {
                    amountOverrideFlag: {
                        enum: [null, undefined],
                    },
                    numberOfDaysOverrideFlag: {
                        enum: [null, undefined],
                    },
                },
            },
        },
        {
            if: {
                required: ['amountOverrideFlag'],
                properties: {
                    amountOverrideFlag: {
                        const: true,
                    },
                },
            },
            then: {
                required: ['amount'],
            },
        },
        {
            if: {
                required: ['numberOfDaysOverrideFlag'],
                properties: {
                    numberOfDaysOverrideFlag: {
                        const: true,
                    },
                },
            },
            then: {
                required: ['numberOfDaysCount'],
            },
        },
        // ProcessTime = '500'
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.ProcessTime,
                    },
                },
            },
            then: {
                anyOf: [
                    { required: ['amount', 'date', 'numberOfDaysCount'] },
                    { not: { required: ['amount', 'date', 'numberOfDaysCount'] } },
                    {
                        required: [
                            'previousAdjustmentAmount',
                            'previousAdjustmentDate',
                            'previousAdjustmentNumberOfDaysCount',
                        ],
                    },
                ],
                properties: {
                    numberOfDaysCount: {
                        type: 'integer',
                        maximum: 2147483647,
                        minimum: 0,
                    },
                },
            },
        },
        // OtherAdjustment = '506'
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.OtherAdjustment,
                    },
                },
            },
            then: {
                anyOf: [{ required: ['amount', 'comment'] }, { required: ['previousAdjustmentAmount'] }],
            },
        },
        // DEFSLOPT1DT = '507'
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.DEFSLOPT1DT,
                    },
                },
            },
            then: {
                anyOf: [
                    { required: ['date'] },
                    { required: ['previousAdjustmentDate'] },
                    { not: { required: ['date', 'previousAdjustmentDate'] } },
                ],
            },
        },
        // OngoingResponsibilities = '513'
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.OngoingResponsibilities,
                    },
                },
            },
            then: {
                anyOf: [{ required: ['amount'] }, { required: ['previousAdjustmentAmount'] }],
            },
        },
        // FireOtherInsurablePerilDamage = '517'
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.FireOtherInsurablePerilDamage,
                    },
                },
            },
            then: {
                anyOf: [{ required: ['amount'] }, { required: ['previousAdjustmentAmount'] }],
            },
        },
        // DelayInSale = '520'
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.DelayInSale,
                    },
                },
            },
            then: {
                anyOf: [{ required: ['amount'] }, { required: ['previousAdjustmentAmount'] }],
            },
        },
        // OngoingLoansAdminRentAdjustment = '524'
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.OngoingLoansAdminRentAdjustment,
                    },
                },
            },
            then: {
                anyOf: [{ required: ['amount'] }, { required: ['previousAdjustmentAmount'] }],
            },
        },
        // DEFSLOPT2DT = '530'
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.DEFSLOPT2DT,
                    },
                },
            },
            then: {
                anyOf: [
                    { required: ['date'] },
                    { required: ['previousAdjustmentDate'] },
                    { not: { required: ['date', 'previousAdjustmentDate'] } },
                ],
            },
        },
        // OtherAdjustment2 = '998'
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: constants_1.OtherAdjustmentCode.OtherAdjustment2,
                    },
                },
            },
            then: {
                anyOf: [{ required: ['amount', 'comment'] }, { required: ['previousAdjustmentAmount'] }],
            },
        },
    ] });
